import { useEffect, useState } from 'react';
import generationApi from './generationApi';

// A transient browser view of engine-owned media, not a second input library.
export default function useRunMediaManifest(jobId, enabled, refreshKey, live) {
  const [view, setView] = useState({ jobId, manifest: null, loading: true, stale: false });
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true, timer, controller;
    async function tick() {
      controller = new AbortController();
      try {
        const next = await generationApi.artifacts(jobId, controller.signal);
        if (!alive) return;
        setView(previous => ({ jobId, loading: false,
          manifest: previous.jobId === jobId && previous.manifest && previous.manifest.manifest_revision === next.manifest_revision ? previous.manifest : next,
          stale: false,
        }));
        const delay = next.poll_after_ms;
        if (delay != null) timer = setTimeout(tick, Math.max(1500, delay));
      } catch {
        if (!alive) return;
        setView(previous => ({ jobId, loading: false, manifest: previous.jobId === jobId ? previous.manifest : null, stale: true }));
        timer = setTimeout(tick, 10000);
      }
    }
    tick();
    return () => { alive = false; clearTimeout(timer); controller?.abort(); };
  }, [jobId, enabled, refreshKey, live]);
  return view.jobId === jobId ? view : { jobId, manifest: null, loading: true, stale: false };
}
